import { useKTX2 as useDreiKTX2 } from "@react-three/drei";

// drei defaults the basis transcoder to a jsdelivr CDN URL. That fetch fails on
// networks where jsdelivr is unreachable, and KTX2Loader reports it against the
// texture URL ("Could not load <texture>: Failed to fetch"), which is misleading.
// Serve the transcoder from public/basis/ instead so texture loading has no
// third-party dependency.
const BASIS_PATH = `${process.env.PUBLIC_URL}/basis/`;

export function useKTX2(input) {
  return useDreiKTX2(input, BASIS_PATH);
}

useKTX2.preload = (url) => useDreiKTX2.preload(url, BASIS_PATH);
useKTX2.clear = (input) => useDreiKTX2.clear(input);
